const PORTRAIT_ROOT = "/images/characters";

// CharacterKey is the source-observed key from CharacterLobby_Table. The
// source archive path is consumed by the offline portrait builder; runtime
// presentation uses only this allowlisted name and normalized asset path.
export const CHARACTER_CLASS_PRESENTATIONS = Object.freeze([
  { characterKey: 1, name: "Warrior", sourceAsset: "combine_etc_classselect_awaken_warrior.dds" },
  { characterKey: 2, name: "Ranger", sourceAsset: "combine_etc_classselect_awaken_ranger.dds" },
  { characterKey: 3, name: "Sorceress", sourceAsset: "combine_etc_classselect_awaken_sorceress.dds" },
  { characterKey: 4, name: "Berserker", sourceAsset: "combine_etc_classselect_awaken_berserker.dds" },
  { characterKey: 5, name: "Tamer", sourceAsset: "combine_etc_classselect_awaken_tamer.dds" },
  { characterKey: 6, name: "Hashashin", sourceAsset: "combine_etc_classselect_awaken_hashashin.dds" },
  { characterKey: 7, name: "Sage", sourceAsset: "combine_etc_classselect_awaken_sage.dds" },
  { characterKey: 9, name: "Guardian", sourceAsset: "combine_etc_classselect_awaken_guardian.dds" },
  { characterKey: 10, name: "Scholar", sourceAsset: "combine_etc_classselect_succesion_pnyw.dds" },
  { characterKey: 11, name: "Drakania", sourceAsset: "combine_etc_classselect_awaken_pqw.dds" },
  { characterKey: 12, name: "Nova", sourceAsset: "combine_etc_classselect_awaken_nova.dds" },
  { characterKey: 13, name: "Corsair", sourceAsset: "combine_etc_classselect_awaken_pfw.dds" },
  { characterKey: 14, name: "Lahn", sourceAsset: "combine_etc_classselect_awaken_lahn.dds" },
  { characterKey: 17, name: "Maegu", sourceAsset: "combine_etc_classselect_succesion_pkow.dds" },
  { characterKey: 18, name: "Shai", sourceAsset: "combine_etc_classselect_awaken_shai.dds" },
  { characterKey: 20, name: "Striker", sourceAsset: "combine_etc_classselect_awaken_striker.dds" },
  { characterKey: 21, name: "Musa", sourceAsset: "combine_etc_classselect_awaken_musa.dds" },
  { characterKey: 22, name: "Maehwa", sourceAsset: "combine_etc_classselect_awaken_maewha.dds" },
  { characterKey: 24, name: "Mystic", sourceAsset: "combine_etc_classselect_awaken_mystic.dds" },
  { characterKey: 25, name: "Valkyrie", sourceAsset: "combine_etc_classselect_awaken_valkyrie.dds" },
  { characterKey: 26, name: "Kunoichi", sourceAsset: "combine_etc_classselect_awaken_kunoichi.dds" },
  { characterKey: 27, name: "Ninja", sourceAsset: "combine_etc_classselect_awaken_ninja.dds" },
  { characterKey: 28, name: "Dark Knight", sourceAsset: "combine_etc_classselect_awaken_dk.dds" },
  { characterKey: 29, name: "Wizard", sourceAsset: "combine_etc_classselect_awaken_wizard.dds" },
  { characterKey: 30, name: "Archer", sourceAsset: "combine_etc_classselect_awaken_archer.dds" },
  { characterKey: 31, name: "Woosa", sourceAsset: "combine_etc_classselect_succesion_pmyf.dds" },
  { characterKey: 32, name: "Witch", sourceAsset: "combine_etc_classselect_awaken_witch.dds" },
  { characterKey: 34, name: "Dosa", sourceAsset: "combine_etc_classselect_succesion_prsa.dds" },
  { characterKey: 35, name: "Deadeye", sourceAsset: "combine_etc_classselect_succesion_pwge.dds" },
  { characterKey: 36, name: "Wukong", sourceAsset: "combine_etc_classselect_succesion_pjkd.dds" },
].map((entry) => Object.freeze({
  ...entry,
  sourcePath: `ui_texture/combine/etc/${entry.sourceAsset}`,
  portraitPath: `${PORTRAIT_ROOT}/class-${entry.characterKey}.webp`,
})));

const PRESENTATION_BY_KEY = new Map(
  CHARACTER_CLASS_PRESENTATIONS.map((entry) => [entry.characterKey, entry]),
);

function resolveAssetUrl(path) {
  const resolver = globalThis.window?.__fishystuffResolveCdnUrl;
  return typeof resolver === "function" ? String(resolver(path) ?? "").trim() : path;
}

export function characterClassPresentation(value) {
  const characterKey = Number(value);
  if (!Number.isSafeInteger(characterKey) || characterKey <= 0) return null;
  const presentation = PRESENTATION_BY_KEY.get(characterKey);
  if (!presentation) return null;
  return {
    characterKey,
    name: presentation.name,
    portraitPath: presentation.portraitPath,
    portraitUrl: resolveAssetUrl(presentation.portraitPath),
  };
}
